import { OrbitControls as n } from "@react-three/drei";
import { useState as c, useRef as a, useEffect as u } from "react";
import { OrbitContext as p } from "./index2.js";
import { useThree as b } from "@react-three/fiber";
import { jsxs as x, Fragment as d, jsx as e } from "react/jsx-runtime";
const j = ({
  children: o,
  ...i
}) => {
  const [s, m] = c({}), f = b((r) => r.camera), t = a(void 0);
  return u(() => {
    m((r) => ({
      ...r,
      orbit: t.current
    }));
  }, [f]), /* @__PURE__ */ x(d, {
    children: [/* @__PURE__ */ e(n, {
      ...i,
      ref: t
    }), /* @__PURE__ */ e(p.Provider, {
      value: s,
      children: o
    })]
  });
};
export {
  j as OrbitCtxProvider
};
//# sourceMappingURL=index.js.map
